import React from 'react';
import { publish } from '@wh/message-bus';
import { Anchor } from '@sitebase/ui-kit/es/buttons';
import { Button } from '@sitebase/ui-kit/es/buttons';

import { softFlagRequested } from '..';

import { CLASSNAME_PREFIX, TRANSLATION_CONTEXT } from '../componentConfig';
import './VerificationPending.scss';

export var VerificationPendingInfo = function VerificationPendingInfo(_ref) {
  var t = _ref.t;
  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification__info' },
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-account-verification__unverified' },
      t(TRANSLATION_CONTEXT)('accountVerification.pending.accountUnverified')
    )
  );
};

export var VerificationPendingAction = function VerificationPendingAction(_ref2) {
  var t = _ref2.t,
      links = _ref2.links;

  var handleVerifyNowClick = function handleVerifyNowClick() {
    return publish(softFlagRequested);
  };
  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification__info' },
    React.createElement(
      Button,
      {
        className: CLASSNAME_PREFIX + '-account-verification__verifyCTA',
        outfit: 'quaternary expanded',
        onClick: handleVerifyNowClick
      },
      t(TRANSLATION_CONTEXT)('accountVerification.pending.verifyNow')
    ),
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-account-verification__link' },
      links && React.createElement(
        Anchor,
        { target: 'blank', href: links.customerSupport, outfit: 'secondary' },
        t(TRANSLATION_CONTEXT)('accountVerification.pending.whyImportant')
      )
    )
  );
};